import React from 'react';

import { FeatureNotAvailable } from '@/components/atoms/FeatureNotAvailable';
import { useIntegratorFeatureFlag } from '@/hooks/useFeatureFlags';

interface Props {
  readonly flagKey: string;
  readonly defaultValue?: boolean;
}

export const IntegratorFeatureFlagged: React.FC<React.PropsWithChildren<Props>> = (
  props: React.PropsWithChildren<Props>,
): React.ReactNode => {
  const { flagKey, defaultValue = false } = props;

  const flagValue = useIntegratorFeatureFlag(flagKey, defaultValue);
  if (flagValue) {
    return props.children;
  }

  return <FeatureNotAvailable />;
};
